import { Component, input } from '@angular/core';
import { SearchStatus } from '@interfaces/search-result.interface';

@Component({
  selector: 'app-search-footer-hints',
  templateUrl: './search-footer-hints.component.html',
  styleUrl: './search-footer-hints.component.scss'
})
export class SearchFooterHintsComponent {
  public readonly status = input<SearchStatus>('empty');
  public readonly totalCount = input(0);
}
